import { t } from "i18next";

/**
 * Util to parse api errors and return copy or custom errors
 * Primary this will return string to components
 */
export const errorParser = (errorMessage: string): string => {
  if (!errorMessage) {
    return '';
  }
  try {
    return JSON.parse(errorMessage)?.error?.message ?? '';
  } catch (e) {
    return t('SOMETHING_WENT_WRONG') + ' ' + t('CHECK_BACK_LATER');
  }
};
